function getJsessionID() {
  return localStorage.getItem("jsessionID") || true;
}
function setJsessionID() {
  return localStorage.getItem("jsessionID");
}
module.exports = { getJsessionID };
